import { EDITOR_MODE } from "@pathwright/blocks-engine"
import { List } from "@pathwright/blocks/src/shared"
import sortBy from "lodash/sortBy"
import { useCallback, useMemo } from "react"
import TasklistItem from "./TasklistItem"
import { removeNewTask } from "./utils"

const Tasklist = (props) => {
  const { data, onChange, mode, blockStyles } = props

  const renderItem = useCallback(
    (itemProps) => {
      return <TasklistItem {...props} {...itemProps} />
    },
    [mode, data.completedTasks, onChange, blockStyles]
  )

  const handleChange = useCallback(
    ({ items }) => {
      const trackProgress = mode === EDITOR_MODE.VIEW

      onChange({ tasks: removeNewTask(items) }, trackProgress)
    },
    [mode, removeNewTask, onChange]
  )

  const autoGenerateItem = useMemo(() => mode === EDITOR_MODE.EDIT, [mode])
  const checkIsAutoGenerated = useCallback((item) => !item.content, [])
  const generateItem = useCallback(
    ({ order }) => ({
      content: "",
      order
    }),
    []
  )

  const items = useMemo(() => sortBy(data.tasks, "order"), [data.tasks])

  return (
    <List
      direction="vertical"
      items={items}
      min={1}
      renderItem={renderItem}
      generateItem={generateItem}
      autoGenerateItem={autoGenerateItem}
      checkIsAutoGenerated={checkIsAutoGenerated}
      onChange={handleChange}
      id={props.id}
    />
  )
}

export default Tasklist
